// extracted by mini-css-extract-plugin
module.exports = {"starIconContainer":"StarredAccount_starIconContainer__3emJ5"};